// src/components/LogoMark.js
// The Post Calendar mark: a lowercase "p" whose bowl is a clock face, on a teal gradient tile.
// Keep in sync with public/favicon.svg and public/brand/ (PNG exports).
import React, { useId } from 'react';

export const APP_NAME = 'Post Calendar';

export default function LogoMark({ size = 28 }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <defs>
        <linearGradient id={`pc-bg-${id}`} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#14B8A6" />
          <stop offset="1" stopColor="#0B3C5D" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill={`url(#pc-bg-${id})`} />
      <path d="M19 50V16" stroke="#fff" strokeWidth="8" strokeLinecap="round" />
      <circle cx="33" cy="28" r="12" stroke="#fff" strokeWidth="8" />
      <path d="M33 23.5V28l3.2 2.4" stroke="#FFB547" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
